'use client'

import { LogoTypeBrand } from '../../components'
import { useTranslate } from '../../hooks'
import { Link } from '../../i18n/navigation'
import { Row, Skeleton } from '@repo/ui/components'
import { ButtonLink } from '../../components'

import { type ILandingHeaderProps } from './landing-header.types'

import dynamic from 'next/dynamic'
import { Cookie } from '@repo/tools'
import { useEffect, useState } from 'react'

const ThemeButton = dynamic(
  () => import('@repo/shared/components').then((mod) => mod.ThemeButton),
  {
    ssr: false,
    loading: () => <Skeleton className='w-[28px] h-[32px]' />,
  },
)

export const LandingHeader = ({ navItems }: ILandingHeaderProps) => {
  const { t } = useTranslate()
  const [isLoggedIn, setIsLoggedIn] = useState(true)

  useEffect(() => {
    const _isLoggedIn = Cookie.get('access_token')
    setIsLoggedIn(Boolean(_isLoggedIn))
  }, [isLoggedIn])

  return (
    <div className='p-md w-full md:w-fit mx-auto'>
      <Row className='h-12 rounded-full w-full items-center justify-between sm:justify-center gap-xl py-md px-lg sticky top-0 z-20 bg-neutral-surface-light/50 backdrop-blur-md'>
        <div className='w-[100px] h-[35px] relative flex items-center justify-center'>
          <Link href='/'>
            <LogoTypeBrand
              alt='logo'
              fill
              sizes='(max-width: 768px) 100vw, 5.25rem'
              priority
              className='object-contain h-auto md:pb-2'
            />
          </Link>
        </div>
        <Row as='nav' className='gap-md items-center w-fit hidden sm:flex'>
          {navItems.map(({ href, label, target }) => (
            <Link
              key={href}
              href={href}
              target={target}
              className='text-xs font-bold cursor-pointer hover:text-primary-main transition-colors'
              prefetch='auto'
            >
              {label}
            </Link>
          ))}
          {!isLoggedIn && (
            <Row className='gap-xs w-fit'>
              <ButtonLink
                href='/auth/login'
                variant='ghost'
                size='xs'
                buttonClassName='w-full px-md'
              >
                {t('common_login')}
              </ButtonLink>
              <ButtonLink
                href='/auth/register'
                variant='fill'
                size='xs'
                buttonClassName='w-full px-md'
              >
                {t('common_register')}
              </ButtonLink>
            </Row>
          )}
        </Row>
        <div className='flex'>
          <ThemeButton />
        </div>
      </Row>
    </div>
  )
}
